/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from "react-redux";
import ListView from "../../../Utils/ListView";
import Highlighter from "react-highlight-words";
import { encode as base64_encode } from "base-64";
import { constant } from "../../../Utils/constants";
import { Tag, Input, Popconfirm, Tooltip,Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import translation from "../../../../../commons/translation";

import {
  getEmergencyWorkOrdersList,
  deleteWorkOrder,
  changeWorkOrderStatus,
  getUsersList,
} from "../../../Utils/FormCalls";
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const AssetMaster = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['WorkOrder', 'Description'],
    firstTitle: 'WorkOrder',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/InventoryDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getEmergencyWorkOrdersList();
      setDataSource(data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchUserList = async () => {
      const users = await getUsersList();
      setUserList(users);
    };
    fetchUserList();
  }, []);

  const editWorkOrder = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const deleteJobplan = async (id) => {
    await deleteWorkOrder(id);
    const data = await getEmergencyWorkOrdersList();
    setDataSource(data);
  };

  const changeStatus = async (id) => {
    await changeWorkOrderStatus(id);
    const data = await getEmergencyWorkOrdersList();
    setDataSource(data);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button
          danger
          
          style={{ width: 90 }}
          onClick={() => {
            clearFilters();
            confirm({ closeDropdown: true });
          }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ color: filtered ? '#1890ff' : undefined, }}
      />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const columns = [
    {
      title: translation(props.translationCache, constant.workOrder),
      dataIndex: 'WorkOrder',
      key: 'WorkOrder',
      filter: true,
      ...getColumnSearchProps('WorkOrder')
    },
    {
      title: translation(props.translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(props.translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName',
      filter: true
    },
    {
      title: translation(props.translationCache, constant.status),
      dataIndex: 'Status',
      key: 'Status',
      render: (text, record) => (
        <Tooltip title={`Click To ${text === 'Active' ? 'Inactive' : 'Active'}`}>
          <span onClick={() => changeStatus(record.Id)}>
            <Tag
              color={
                text && text === 'Active' ? '#87d068' : text === 'Inactive' ? '#ff4d4f' : 'gold'
              }
              key={text}
            >
              {text}
            </Tag>
          </span>
        </Tooltip>
      )
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            disabled={record.Status === 'Inactive'}
            style={{ marginRight: '5px' }}
            onClick={() => editWorkOrder(record)}
          >
            <Tooltip title={'Edit'}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(
              props.translationCache,
              constant.areYouSureThatYouWantToDeleteTheEmergencyWorkOrder
            )}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteJobplan(record.Id)}
            okText={translation(props.translationCache, constant.yes)}
            cancelText={translation(props.translationCache, constant.no)}
          >
            <Button>
              <Tooltip title={'Delete'}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        userList={userList}
        config={config}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(AssetMaster);